module.exports = __webpack_public_path__ + "assets/img/icon13.69945553.png";